export const RESUME_URL = "https://drive.google.com/file/d/1EMcVbWcmbyyjPmEEHOU01mNc92nCNAjM/view";
